(function () {
    'use strict';

    angular
        .module('atheer.ticket', [

        ]);
})();
